import { isSafari, isMobileSafari } from 'react-device-detect';

export type ScannerSound =
  | 'orderSuccess'
  | 'orderFailure'
  | 'shelfSuccess'
  | 'shelfFailure'
  | 'scannerBlocked';

const soundMap = new Map<ScannerSound, HTMLAudioElement>();
const preload = () => {
  soundMap.set('orderSuccess', new Audio('/audio/sucsessScannOrderId.mp3'));
  soundMap.set('orderFailure', new Audio('/audio/failureScannOrderId.mp3'));
  soundMap.set('shelfSuccess', new Audio('/audio/sucsessScannShelfId.mp3'));
  soundMap.set('shelfFailure', new Audio('/audio/failureScannShelfId.mp3'));
  soundMap.set('scannerBlocked', new Audio('/audio/scanner_blocked.mp3'));
};

const play = (sound: ScannerSound) => {
  if (isSafari || isMobileSafari) {
    return null;
  }
  const audioElement = soundMap.get(sound);
  if (!!audioElement) {
    audioElement.currentTime = 0;
    audioElement.muted = false;
    audioElement.play();
  }
};

export { play, preload };
